import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import NavMenu from '@/common/navmenu.vue';
import Footer from '@/common/footer.vue';
import { orderList, createOrderAgain, orderNum } from '@/services/http';
import { dateTimeFormatter as _dateTimeFormatter, readCookie, dateFormatter as _dateFormatter } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.ordernumber = {
      received: 0
    };
    _this.loading = false;
    _this.keyword = '';
    _this.orderList = [];
    _this.activeName = 'first';
    _this.isNodata = true;
    _this.pageNo = 1;
    _this.pageSize = 10;
    _this.currentpage = 1;
    _this.totalnumber = 0;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getOrderNum();
      this.getOrderList();
    }
  }, {
    key: "getOrderNum",
    value: function () {
      var _getOrderNum = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var anchor, ordernumber;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              anchor = readCookie('anchor');
              _context.next = 3;
              return orderNum({
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                companyId: 1
              });
            case 3:
              ordernumber = _context.sent;
              this.ordernumber = ordernumber.data.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getOrderNum() {
        return _getOrderNum.apply(this, arguments);
      }
      return getOrderNum;
    }() // 获取订单列表
  }, {
    key: "getOrderList",
    value: function () {
      var _getOrderList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var anchor, status, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              anchor = readCookie('anchor');
              this.loading = true;
              status = 3;
              if (this.activeName === 'first') {
                status = 3;
              } else if (this.activeName === 'second') {
                status = 4;
              }
              _context2.next = 6;
              return orderList({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                status: status,
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                keyword: this.keyword,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                companyId: 1
              });
            case 6:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.orderList = res.data.data.list;
                this.totalnumber = res.data.data.total;
                this.isNodata = this.orderList.length === 0;
              } else {
                this.$message.error('服务器异常!');
              }
              this.loading = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getOrderList() {
        return _getOrderList.apply(this, arguments);
      }
      return getOrderList;
    }() // 评价
  }, {
    key: "comment",
    value: function () {
      var _comment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(details) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              sessionStorage.setItem('commentDetails', JSON.stringify(details));
              this.$router.push({
                name: 'Comment'
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function comment(_x) {
        return _comment.apply(this, arguments);
      }
      return comment;
    }() // 再次购买
  }, {
    key: "buyAgain",
    value: function () {
      var _buyAgain = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(item) {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              anchor = readCookie('anchor');
              _context4.next = 3;
              return createOrderAgain({
                orderNo: item.orderNo,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : ''
              });
            case 3:
              res = _context4.sent;
              if (res.data.code === 100) {
                this.$router.push('/card');
              } else {
                this.$message.error(res.data.message);
              }
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function buyAgain(_x2) {
        return _buyAgain.apply(this, arguments);
      }
      return buyAgain;
    }()
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getOrderList();
      window.scrollTo(0, 0);
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getOrderList();
      window.scrollTo(0, 0);
    }
  }, {
    key: "search",
    value: function search() {
      this.pageSize = 10;
      this.pageNo = 1;
      this.getOrderList();
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu
  },
  filters: {
    dateTimeFormatter: function dateTimeFormatter(value) {
      return _dateTimeFormatter(value);
    },
    dateFormatter: function dateFormatter(value) {
      return _dateFormatter(value);
    }
  }
})], default_1);
export default default_1;